/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления профилями шифрования
 */

/**
 * Сервис профилей шифрования
 */
export class EncryptionProfileServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения шифрования по идентификатору.
   * Поддерживает создание и обновление.
   * Метод доступен для: device_admin
   */
  PostEncryptionProfile = (req: PostEncryptionProfileRequestDto, init?: RequestInit): Promise<PostEncryptionProfileResponseDto> => {
    return fm.request<PostEncryptionProfileRequestDto, PostEncryptionProfileResponseDto>(`${this.host}/encryption_profile/api/v1/encryption_profile`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения профиля шифрования по идентификатору.
   * Метод доступен для: admin, service, bti, device_admin
   */
  GetEncryptionProfile = (req: GetEncryptionProfileRequestDto, init?: RequestInit): Promise<GetEncryptionProfileResponseDto> => {
    return fm.request<GetEncryptionProfileRequestDto, GetEncryptionProfileResponseDto>(`${this.host}/encryption_profile/api/v1/encryption_profile/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка профилей шифрования.
   * Метод доступен для: admin, service, bti, device_admin
   */
  GetEncryptionProfileList = (req?: GetEncryptionProfileListRequestDto, init?: RequestInit): Promise<GetEncryptionProfileListResponseDto[]> => {
    return fm.list<GetEncryptionProfileListRequestDto, GetEncryptionProfileListResponseDto>(`${this.host}/encryption_profile/api/v1/encryption_profile/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества профилей шифрования.
   * Метод доступен для: admin, service, bti, device_admin
   */
  GetEncryptionProfileCount = (req?: GetEncryptionProfileCountRequestDto, init?: RequestInit): Promise<GetEncryptionProfileCountResponseDto> => {
    return fm.request<GetEncryptionProfileCountRequestDto, GetEncryptionProfileCountResponseDto>(`${this.host}/encryption_profile/api/v1/encryption_profile/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления профиля шифрования.
   * Метод доступен для: admin, service, device_admin
   */
  DeleteEncryptionProfile = (req: DeleteEncryptionProfileRequestDto, init?: RequestInit): Promise<DeleteEncryptionProfileResponseDto> => {
    return fm.request<DeleteEncryptionProfileRequestDto, DeleteEncryptionProfileResponseDto>(`${this.host}/encryption_profile/api/v1/encryption_profile/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод разархивации шифрования по идентификатору.
   * Метод доступен для: admin, service, device_admin
   */
  PostEncryptionProfileRestore = (req: PostEncryptionProfileRestoreRequestDto, init?: RequestInit): Promise<PostEncryptionProfileRestoreResponseDto> => {
    return fm.request<PostEncryptionProfileRestoreRequestDto, PostEncryptionProfileRestoreResponseDto>(`${this.host}/encryption_profile/api/v1/encryption_profile/restore/${encodeURIComponent(req.id)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов профиля шифрования.
 */
export enum EncryptionProfileType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Тип SL3
   */
  SL3 = "SL3",
}
/**
 * Справочник типов профиля шифрования.
 */
export type EncryptionProfileTypeResponseEnum = keyof typeof EncryptionProfileType
/**
 * Справочник типов профиля шифрования.
 */
export type EncryptionProfileTypeRequestEnum = Exclude<EncryptionProfileTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки;
 */
export enum EncryptionProfilePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки;
 */
export type EncryptionProfilePagingDirectionTypeResponseEnum = keyof typeof EncryptionProfilePagingDirectionType
/**
 * Справочник типов направлений сортировки;
 */
export type EncryptionProfilePagingDirectionTypeRequestEnum = Exclude<EncryptionProfilePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum EncryptionProfilePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type EncryptionProfilePagingOrderByTypeResponseEnum = keyof typeof EncryptionProfilePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type EncryptionProfilePagingOrderByTypeRequestEnum = Exclude<EncryptionProfilePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления профиля шифрования
 */
export type DeleteEncryptionProfileRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления профиля шифрования
 */
export type DeleteEncryptionProfileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteEncryptionProfileResponseErrorDto
}>
/**
 * Ошибка запроса удаления профиля шифрования
 */
export type DeleteEncryptionProfileResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Существуют устройства, связанные с этим профилем шифрования
   */
  readonly linkedDevicesExists: DeleteEncryptionProfileResponseErrorLinkedDevicesExistsRequestDto
}>
/**
 * Ошибка запроса удаления профиля шифрования
 */
export type DeleteEncryptionProfileResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Существуют устройства, связанные с этим профилем шифрования
   */
  readonly linkedDevicesExists: DeleteEncryptionProfileResponseErrorLinkedDevicesExistsDto
}>
/**
 * Существуют устройства, связанные с этим профилем шифрования.
 * Следует отвязать устройства перед удалением профиля
 */
export type DeleteEncryptionProfileResponseErrorLinkedDevicesExistsRequestDto = {
}
/**
 * Существуют устройства, связанные с этим профилем шифрования.
 * Следует отвязать устройства перед удалением профиля
 */
export type DeleteEncryptionProfileResponseErrorLinkedDevicesExistsDto = {
}
/**
 * Профиль шифрования.
 * # Описание модели
 */
export type EncryptionProfileRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * # Диапазон: 3..64
   */
  name: string
  /**
   * Описание.
   * # Диапазон: 3..1000
   */
  description?: string | null
  /**
   * Тип профиля шифрования
   */
  type: EncryptionProfileTypeRequestEnum
  /**
   * Номер сектора.
   * # Диапазон: 0..15
   */
  sectorNumber?: number
  /**
   * Номер блока.
   * # Диапазон: 0..3
   */
  blockNumber?: number
  /**
   * Индекс первого символа для секрета.
   * # Диапазон: 0..31
   */
  startIndex?: number
  /**
   * Индекс последнего символа для секрета.
   * # Диапазон: 0..31
   */
  endIndex?: number
  /**
   * Пароль A профиля.
   * # Диапазон: 16..32
   */
  secretA: string
  /**
   * Пароль B профиля.
   * # Диапазон: 16..32
   */
  secretB: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt?: string | null
}
/**
 * Профиль шифрования.
 * # Описание модели
 */
export type EncryptionProfileResponseDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * # Диапазон: 3..64
   */
  name: string
  /**
   * Описание.
   * # Диапазон: 3..1000
   */
  description: string | null
  /**
   * Тип профиля шифрования
   */
  type: EncryptionProfileTypeResponseEnum
  /**
   * Номер сектора.
   * # Диапазон: 0..15
   */
  sectorNumber: number
  /**
   * Номер блока.
   * # Диапазон: 0..3
   */
  blockNumber: number
  /**
   * Индекс первого символа для секрета.
   * # Диапазон: 0..31
   */
  startIndex: number
  /**
   * Индекс последнего символа для секрета.
   * # Диапазон: 0..31
   */
  endIndex: number
  /**
   * Зашифрованный пароль B профиля
   */
  readonly encryptedSecretA: string
  /**
   * Зашифрованный пароль B профиля
   */
  readonly encryptedSecretB: string
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime?
   */
  readonly deletedAt: string | null
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type EncryptionProfileSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: EncryptionProfileSavingErrorConflictRequestDto
  /**
   * Указанный диапазон не соответствует минимальному значению
   */
  readonly rangeIsTooSmall: EncryptionProfileSavingErrorRangeIsTooSmallRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type EncryptionProfileSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: EncryptionProfileSavingErrorConflictResponseDto
  /**
   * Указанный диапазон не соответствует минимальному значению
   */
  readonly rangeIsTooSmall: EncryptionProfileSavingErrorRangeIsTooSmallResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type EncryptionProfileSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type EncryptionProfileSavingErrorConflictResponseDto = {
}
/**
 * Указанный диапазон не соответствует минимальному значению.
 * Причины:
 * - Модуль разности между полями start_index и end_index меньше 7
 */
export type EncryptionProfileSavingErrorRangeIsTooSmallRequestDto = {
}
/**
 * Указанный диапазон не соответствует минимальному значению.
 * Причины:
 * - Модуль разности между полями start_index и end_index меньше 7
 */
export type EncryptionProfileSavingErrorRangeIsTooSmallResponseDto = {
}
/**
 * Фильтр по профилям шифрования
 */
export type EncryptionProfileFilterRequestDto = {
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text?: string
  /**
   * По типам профиля шифрования
   */
  types?: EncryptionProfileTypeResponseEnum[]
  /**
   * Показывать удаленные
   */
  showDeleted?: boolean | null
}
/**
 * Фильтр по профилям шифрования
 */
export type EncryptionProfileFilterResponseDto = {
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text: string
  /**
   * По типам профиля шифрования
   */
  types: EncryptionProfileTypeResponseEnum[]
  /**
   * Показывать удаленные
   */
  showDeleted: boolean | null
}
/**
 * Постраничный вывод
 */
export type EncryptionProfilePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: EncryptionProfilePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: EncryptionProfilePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type EncryptionProfilePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: EncryptionProfilePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: EncryptionProfilePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос получения количества профилей шифрования
 */
export type GetEncryptionProfileCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: EncryptionProfileFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества профилей шифрования
 */
export type GetEncryptionProfileCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего устройтсв
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetEncryptionProfileCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества профилей шифрования
 */
export type GetEncryptionProfileCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества профилей шифрования
 */
export type GetEncryptionProfileCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка профилей шифрования
 */
export type GetEncryptionProfileListRequestDto = {
  /**
   * Фильтр
   */
  filter?: EncryptionProfileFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: EncryptionProfilePagingRequestDto
}>
/**
 * Ответ на получение списка профилей шифрования
 */
export type GetEncryptionProfileListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly data: EncryptionProfileResponseDto
  /**
   * Ошибка
   */
  readonly error: GetEncryptionProfileListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка профилей шифрования
 */
export type GetEncryptionProfileListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка профилей шифрования
 */
export type GetEncryptionProfileListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения профиля шифрования
 */
export type GetEncryptionProfileRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения профиля шифрования
 */
export type GetEncryptionProfileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly data: EncryptionProfileResponseDto
  /**
   * Ошибка
   */
  readonly error: GetEncryptionProfileResponseErrorDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetEncryptionProfileResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetEncryptionProfileResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос сохранения шифрования по идентификатору
 */
export type PostEncryptionProfileRequestDto = {
  /**
   * Профиль шифрования
   */
  data: EncryptionProfileRequestDto
}
/**
 * Ответ на запрос сохранения шифрования по идентификатору
 */
export type PostEncryptionProfileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly data: EncryptionProfileResponseDto
  /**
   * Ошибка
   */
  readonly error: PostEncryptionProfileResponseErrorDto
}>
/**
 * Ошибка запроса сохранения профиля шифрования
 */
export type PostEncryptionProfileResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: EncryptionProfileSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения профиля шифрования
 */
export type PostEncryptionProfileResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: EncryptionProfileSavingErrorResponseDto
}>
/**
 * Запрос разархивации шифрования по идентификатору
 */
export type PostEncryptionProfileRestoreRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Отвест на запрос разархивации шифрования по идентификатору
 */
export type PostEncryptionProfileRestoreResponseDto = {
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления профиля шифрования
   */
  "DeleteEncryptionProfileRequest": {
    "kind": "class",
    "text": "Запрос удаления профиля шифрования",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления профиля шифрования
   */
  "DeleteEncryptionProfileResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления профиля шифрования",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteEncryptionProfileResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления профиля шифрования
   */
  "DeleteEncryptionProfileResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления профиля шифрования",
    "fields": {
      /**
       * Существуют устройства, связанные с этим профилем шифрования
       */
      "linkedDevicesExists": {
        "type": "DeleteEncryptionProfileResponse.Error.LinkedDevicesExists",
        "text": "Существуют устройства, связанные с этим профилем шифрования",
      },
    },
  },
  /**
   * Существуют устройства, связанные с этим профилем шифрования.
   * Следует отвязать устройства перед удалением профиля
   */
  "DeleteEncryptionProfileResponse.Error.LinkedDevicesExists": {
    "kind": "class",
    "text": "Существуют устройства, связанные с этим профилем шифрования.\nСледует отвязать устройства перед удалением профиля",
  },
  /**
   * Профиль шифрования.
   * # Описание модели
   */
  "EncryptionProfile": {
    "kind": "class",
    "text": "Профиль шифрования.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
      },
      /**
       * Наименование.
       * # Диапазон: 3..64
       */
      "name": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 3..64",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Описание.
       * # Диапазон: 3..1000
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание.\n# Диапазон: 3..1000",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 1000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1000"
          },
        }
      },
      /**
       * Тип профиля шифрования
       */
      "type": {
        "type": "EncryptionProfile.Type",
        "text": "Тип профиля шифрования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер сектора.
       * # Диапазон: 0..15
       */
      "sectorNumber": {
        "type": "int32",
        "text": "Номер сектора.\n# Диапазон: 0..15",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 15,
            "message": "Значение не входит в допустимый диапазон. Максимум: 15"
          },
        }
      },
      /**
       * Номер блока.
       * # Диапазон: 0..3
       */
      "blockNumber": {
        "type": "int32",
        "text": "Номер блока.\n# Диапазон: 0..3",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Максимум: 3"
          },
        }
      },
      /**
       * Индекс первого символа для секрета.
       * # Диапазон: 0..31
       */
      "startIndex": {
        "type": "int32",
        "text": "Индекс первого символа для секрета.\n# Диапазон: 0..31",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 31,
            "message": "Значение не входит в допустимый диапазон. Максимум: 31"
          },
        }
      },
      /**
       * Индекс последнего символа для секрета.
       * # Диапазон: 0..31
       */
      "endIndex": {
        "type": "int32",
        "text": "Индекс последнего символа для секрета.\n# Диапазон: 0..31",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 31,
            "message": "Значение не входит в допустимый диапазон. Максимум: 31"
          },
        }
      },
      /**
       * Пароль A профиля.
       * # Диапазон: 16..32
       */
      "secretA": {
        "type": "string",
        "text": "Пароль A профиля.\n# Диапазон: 16..32",
        "rules": {
          "minLength": {
            "value": 16,
            "message": "Значение не входит в допустимый диапазон. Минимум: 16"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Зашифрованный пароль B профиля
       */
      "encryptedSecretA": {
        "type": "string",
        "text": "Зашифрованный пароль B профиля",
      },
      /**
       * Пароль B профиля.
       * # Диапазон: 16..32
       */
      "secretB": {
        "type": "string",
        "text": "Пароль B профиля.\n# Диапазон: 16..32",
        "rules": {
          "minLength": {
            "value": 16,
            "message": "Значение не входит в допустимый диапазон. Минимум: 16"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Зашифрованный пароль B профиля
       */
      "encryptedSecretB": {
        "type": "string",
        "text": "Зашифрованный пароль B профиля",
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime?
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime?",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "EncryptionProfile.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "EncryptionProfile.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Указанный диапазон не соответствует минимальному значению
       */
      "rangeIsTooSmall": {
        "type": "EncryptionProfile.SavingError.RangeIsTooSmall",
        "text": "Указанный диапазон не соответствует минимальному значению",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at оличаются
   */
  "EncryptionProfile.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at оличаются",
  },
  /**
   * Указанный диапазон не соответствует минимальному значению.
   * Причины:
   * - Модуль разности между полями start_index и end_index меньше 7
   */
  "EncryptionProfile.SavingError.RangeIsTooSmall": {
    "kind": "class",
    "text": "Указанный диапазон не соответствует минимальному значению.\nПричины:\n- Модуль разности между полями start_index и end_index меньше 7",
  },
  /**
   * Фильтр по профилям шифрования
   */
  "EncryptionProfileFilter": {
    "kind": "class",
    "text": "Фильтр по профилям шифрования",
    "fields": {
      /**
       * Поиск по тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование;
       * # - Описание
       */
      "text": {
        "type": "string",
        "text": "Поиск по тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование;\n# - Описание",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По типам профиля шифрования
       */
      "types": {
        "type": "EncryptionProfile.Type",
        "text": "По типам профиля шифрования",
      },
      /**
       * Показывать удаленные
       */
      "showDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Показывать удаленные",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "EncryptionProfilePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "EncryptionProfilePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "EncryptionProfilePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос получения количества профилей шифрования
   */
  "GetEncryptionProfileCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества профилей шифрования",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "EncryptionProfileFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества профилей шифрования
   */
  "GetEncryptionProfileCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества профилей шифрования",
    "fields": {
      /**
       * Всего устройтсв
       */
      "data": {
        "type": "int32",
        "text": "Всего устройтсв",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetEncryptionProfileCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества профилей шифрования
   */
  "GetEncryptionProfileCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества профилей шифрования",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка профилей шифрования
   */
  "GetEncryptionProfileListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка профилей шифрования",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "EncryptionProfileFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "EncryptionProfilePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка профилей шифрования
   */
  "GetEncryptionProfileListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка профилей шифрования",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetEncryptionProfileListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка профилей шифрования
   */
  "GetEncryptionProfileListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка профилей шифрования",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения профиля шифрования
   */
  "GetEncryptionProfileRequest": {
    "kind": "class",
    "text": "Запрос получения профиля шифрования",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения профиля шифрования
   */
  "GetEncryptionProfileResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения профиля шифрования",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetEncryptionProfileResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения баннера
   */
  "GetEncryptionProfileResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения шифрования по идентификатору
   */
  "PostEncryptionProfileRequest": {
    "kind": "class",
    "text": "Запрос сохранения шифрования по идентификатору",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения шифрования по идентификатору
   */
  "PostEncryptionProfileResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения шифрования по идентификатору",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostEncryptionProfileResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения профиля шифрования
   */
  "PostEncryptionProfileResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения профиля шифрования",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "EncryptionProfile.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос разархивации шифрования по идентификатору
   */
  "PostEncryptionProfileRestoreRequest": {
    "kind": "class",
    "text": "Запрос разархивации шифрования по идентификатору",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Отвест на запрос разархивации шифрования по идентификатору
   */
  "PostEncryptionProfileRestoreResponse": {
    "kind": "class",
    "text": "Отвест на запрос разархивации шифрования по идентификатору",
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов профиля шифрования.
   */
  "EncryptionProfile.Type": {
    "kind": "enum",
    "text": "Справочник типов профиля шифрования.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Тип SL3
       */
      "SL3": {
        "i": 1,
        "text": "Тип SL3",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки;
   */
  "EncryptionProfilePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки;",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "EncryptionProfilePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 2,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 3,
        "text": "Дата создания",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 4,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}